/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { useIntl } from 'react-intl';

import { cssMap, cx, jsx } from '@atlaskit/css';
import { RovoIcon } from '@atlaskit/logo';
import { Box, Inline, Text } from '@atlaskit/primitives/compiled';

import { i18n } from './messages';

const styles = cssMap({
	text: {
		textDecoration: 'none',
	},
});

type Variant = 'summary' | 'define';

interface AIAwarenessProps {
	variant?: Variant;
}

export const AIAwareness = ({ variant = 'summary' }: AIAwarenessProps): JSX.Element => {
	const MESSAGE_MAP = {
		summary: i18n.rovoAwarenessMessage,
		define: i18n.rovoAwarenessDefineMessage,
	} as const;

	const { formatMessage } = useIntl();

	const message = MESSAGE_MAP[variant];

	return (
		<Box xcss={cx(styles.text)}>
			<Inline alignBlock="center" space="space.050">
				<RovoIcon size="xxsmall" appearance="brand" shouldUseNewLogoDesign />
				<Text color="color.text.subtlest">{formatMessage(message)}</Text>
			</Inline>
		</Box>
	);
};
